import {
  anUpdateAggregationRule,
  mockUpdateAggregationRuleBuilderOperationMutation,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

import { ruleBuilderQuery_aggregation_updated } from '../queries/RuleBuilderQueryOperation.mocks';

export const updateAggregationRuleResponse = {
  __typename: 'Mutation' as const,
  updateAggregationRule: anUpdateAggregationRule({
    data: {
      ...ruleBuilderQuery_aggregation_updated.rule,
    },
  }),
};

export const handlers = [
  mockUpdateAggregationRuleBuilderOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        // @ts-ignore windowSizeInMillisecnds is aliased which causes issues with typing since MSW doesn't handle this case
        data: updateAggregationRuleResponse,
      });
    }
  ),
];
